const App = {
  state: {
    navList: "",
    navHeight: 0,
    navLastActive: "",
    navBG: "",
    bgTranstition: "",
  },
};

export default App;
